const locale = {
  placeholder: 'Demê hilbijêre'
};
export default locale;